export default "__VITE_ASSET__DcVyIBt3__ 100w";